import {
  LIST_SP_TAB_HISTORY,
  LIST_SP_TAB_PROGRESS,
  LIST_SP_TAB_SUMMARY,
} from '../constant';

export {
  LIST_SP_TAB_HISTORY,
  LIST_SP_TAB_PROGRESS,
  LIST_SP_TAB_SUMMARY,
} from '../constant';

export const LIST_SP_AVAILABLE_TABS = [
  LIST_SP_TAB_HISTORY,
  LIST_SP_TAB_PROGRESS,
  LIST_SP_TAB_SUMMARY,
];

export const PROMISE_REJECTED = 'rejected';
export const PROMISE_FULFILLED = 'fulfilled';
export const PROGRESS_KEYS_TO_EXCLUDE = [
  'Done',
  'Pending',
  'Progress',
  'Total',
];

export const HISTORY_ICONS_MAPPING = {
  certificationdiscontinued: 'Reject',
  canceled: 'Reject',
  cancelled: 'Reject',
  certificationexported: 'Export',
  exported: 'Export',
  reassignedcertification: 'ReassignItem',
  reassigned: 'ReassignItem',
  certificationlocked: 'Check',
  completed: 'Check',
  default: 'None',
};

export const HISTORY_COLORS_MAPPING = {
  certificationdiscontinued: 'info',
  canceled: 'info',
  certificationexported: 'info',
  exported: 'info',
  reassignedcertification: 'info',
  reassigned: 'info',
  certificationlocked: 'success',
  completed: 'success',
  default: 'info',
};

export const HISTORY_USER_ACTION_LABEL_MAPPING = {
  certificationdiscontinued: 'Cancelled by',
  canceled: 'Cancelled by',
  certificationexported: 'Exported by',
  exported: 'Exported by',
  reassignedcertification: 'Reassigned from',
  reassigned: 'Reassigned from',
  certificationlocked: 'Completed by',
  completed: 'Completed by',
  default: 'Actioned by',
};

export const HISTORY_DATE_ACTION_LABEL_MAPPING = {
  certificationdiscontinued: 'Cancelled on',
  canceled: 'Cancelled on',
  certificationexported: 'Exported on',
  exported: 'Exported on',
  reassignedcertification: 'Reassigned on',
  reassigned: 'Reassigned on',
  certificationlocked: 'Completed on',
  completed: 'Completed on',
  default: 'Actioned on',
};

export const VALID_HISTORY_ACTIONS = [
  'certificationdiscontinued',
  'cancelled',
  'certificationexported',
  'exported',
  'reassignedcertification',
  'reassigned',
  'certificationlocked',
  'completed',
];
